import { useState } from 'react';
import AdvancedSchedule from './AdvancedSchedule';
import BlockedDatesManager from './BlockedDatesManager';
import CapacityOverview from './CapacityOverview';
import { Calendar, Ban, Users } from 'lucide-react';

type ScheduleTab = 'calendar' | 'blocked-dates' | 'capacity';

export default function Schedule() {
  const [activeTab, setActiveTab] = useState<ScheduleTab>('calendar');

  const tabs = [
    { id: 'calendar' as const, label: 'Calendar', icon: Calendar },
    { id: 'blocked-dates' as const, label: 'Blocked Dates', icon: Ban },
    { id: 'capacity' as const, label: 'Capacity Overview', icon: Users }
  ];

  return (
    <div className="space-y-6">
      {/* Tab Navigation */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === tab.id
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <Icon
                  className={`mr-2 h-5 w-5 ${
                    activeTab === tab.id ? 'text-indigo-500' : 'text-gray-400 group-hover:text-gray-500'
                  }`}
                />
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'calendar' && <AdvancedSchedule />}
        {activeTab === 'blocked-dates' && <BlockedDatesManager />}
        {activeTab === 'capacity' && <CapacityOverview />}
      </div>
    </div>
  );
}